"use strict";
/* istanbul ignore file */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.AllThemes = exports.addStateFunctions = void 0; // / <reference path="../types/modules.d.ts" />

var index_js_1 = __importDefault(require("@paradigm/themes/base/default/index.js"));

var index_js_2 = __importDefault(require("@paradigm/themes/base/desktop_s/index.js"));

var index_js_3 = __importDefault(require("@paradigm/themes/calendar/desktop_s/index.js"));

var index_js_4 = __importDefault(require("@paradigm/themes/calls/desktop_s/index.js"));

var index_js_5 = __importDefault(require("@paradigm/themes/mailID/desktop_s/index.js"));

var index_js_6 = __importDefault(require("@paradigm/themes/octavius/desktop_s/index.js"));

var index_js_7 = __importDefault(require("@paradigm/themes/octavius/subthemes/black/index.js"));

var index_js_8 = __importDefault(require("@paradigm/themes/octavius/subthemes/dit/index.js"));

var color_1 = __importDefault(require("color"));

exports.addStateFunctions = function (theme) {
  return __assign(__assign({}, theme), {
    stateHover: function stateHover(colorHover) {
      if (colorHover === 'transparent') {
        return "rgba(" + theme.colorState.normal + "," + theme.toneValueHover + ")";
      }

      return color_1.default(colorHover).mix(color_1.default(theme.colorState.normal), theme.toneValueHover).hex();
    },
    stateActive: function stateActive(colorActive) {
      if (colorActive === 'transparent') {
        return "rgba(" + theme.colorState.normal + "," + theme.toneValueActive + ")";
      }

      return color_1.default(colorActive).mix(color_1.default(theme.colorState.normal), theme.toneValueActive).hex();
    },
    stateFocus: function stateFocus(colorFocus) {
      if (colorFocus === 'transparent') {
        return "rgba(" + theme.colorState.normal + "," + theme.toneValueFocus + ")";
      }

      return color_1.default(colorFocus).mix(color_1.default(theme.colorState.normal), theme.toneValueFocus).hex();
    },
    stateDisabled: function stateDisabled(colorDisabled) {
      return color_1.default(colorDisabled).alpha(theme.toneValueBase).rgb().string();
    }
  });
};

exports.AllThemes = {
  octavius: exports.addStateFunctions(index_js_6.default),
  octaviusBlack: exports.addStateFunctions(__assign(__assign(__assign({}, index_js_2.default), index_js_6.default), index_js_7.default)),
  base: exports.addStateFunctions(index_js_2.default),
  dit: exports.addStateFunctions(__assign(__assign({}, index_js_2.default), index_js_8.default)),
  black: exports.addStateFunctions(__assign(__assign({}, index_js_2.default), index_js_7.default)),
  touch: exports.addStateFunctions(index_js_1.default),
  mailID: exports.addStateFunctions(index_js_5.default),
  calendar: exports.addStateFunctions(index_js_3.default),
  calls: exports.addStateFunctions(index_js_4.default)
};
exports.theme = exports.AllThemes.octavius;